const home = "/";
const partnerTerms = "/partner-terms";
const terms = "/terms";
const dashboardHome = "/home";
const ourTeam = "/ourTeam";

// Auth routes
const linkedinCallback = "/linkedin/callback";
const registerRole = "/registerRole";
const profileForm = "/profileForm";

// My Calendar
const myCalendar = "/myCalendar";

// Manage Slots
const publishSlots = "/publishSlots";
const editSlots = "/editSlots";

// Payments
const payments = "/payments";

// Profile
const profile = "/profile";

// Blogs
const blog = "/blog";
const singleBlog = "/blog/:blogId";

export const ROUTES = {
  HOME: home,
  PARTNER_TERMS: partnerTerms,
  TERMS: terms,
  DASHBOARD_HOME: dashboardHome,
  LINKEDIN_CALLBACK: linkedinCallback,
  REGISTER_ROLE: registerRole,
  PROFILE_FORM: profileForm,
  MY_CALENDAR: myCalendar,
  PUBLISH_SLOTS: publishSlots,
  EDIT_SLOTS: editSlots,
  PAYMENTS: payments,
  PROFILE: profile,
  OUR_TEAM: ourTeam,
  BLOG: blog,
  SINGLE_BLOG: singleBlog,
};
